import clsx from "clsx";

import { Spinner } from "src/core/components/custom-ui/spinner";
import { HomeCardHeader } from "src/core/components/home/HomeCardHeader";
import { Card } from "src/core/components/ui/card";
import { Variant } from "src/core/constants/colors";

type HomeCardProps = {
  isLoading: boolean;
  icon: React.ComponentType;
  title: string;
  subtitle: string;
  number: number;
  label: string;
  folderLabel: string;
  variant: Variant;
  onClick?: () => void;
};

const variantStyles = {
  orange: {
    header: "bg-orange-light",
    text: "text-orange-medium",
    border: "hover:border-orange-light",
  },
  blue: {
    header: "bg-blue-light",
    text: "text-blue-medium",
    border: "hover:border-blue-light",
  },
  violet: {
    header: "bg-violet-light",
    border: "hover:border-violet-light",
    text: "text-violet-medium",
  },
  green: {
    header: "bg-green-light",
    border: "hover:border-green-light",
    text: "text-green-medium",
  },
  red: {
    header: "bg-red-card-light",
    border: "hover:border-red-card-light",
    text: "text-red-card",
  },
} as const;

export const HomeCard: React.FC<HomeCardProps> = ({
  isLoading,
  icon,
  title,
  subtitle,
  number,
  label,
  folderLabel,
  variant,
  onClick,
}) => {
  const styles = variantStyles[variant];

  return (
    <Card
      className={clsx("home-card", styles.text, styles.border)}
      onClick={onClick}
      data-testid={`home-card-variant-${variant}`}
    >
      <HomeCardHeader
        titleKey={title}
        subtitleKey={subtitle}
        icon={icon}
        stylesHeader={styles.header}
        stylesText={styles.text}
      />
      <div className="home-card-content">
        <span className="home-card-number" data-testid="home-card-number">
          {isLoading ? <Spinner data-testid="home-card-spinner" /> : number}
        </span>
        <div className="home-card-label-container">
          <span className="home-card-label-folder">{folderLabel}</span>
          <span className="home-card-label">{label}</span>
        </div>
      </div>
    </Card>
  );
};
